import ForecastModeBadge from './ForecastModeBadge.jsx';
import { formatDate, formatHtTtc } from '../../lib/format.js';

/**
 * Ligne de lecture seule pour afficher un item prévisionnel dans le drill-down
 * de la page Cash-flow (PeriodCategoryPanel en mode forecasts/both).
 *
 * Pas d'édition ni suppression — le contexte est un aperçu, pas la page Prévisionnels.
 *
 * Props :
 *   item — { mode, id, label, amount_cents, date, category_id,
 *            amount_cents_vat?: number|null }
 *          tel que renvoyé par GET /v1/cash-flow/breakdown
 *          (forecasts utilisent amount_cents_vat pour la TVA)
 */
export default function ForecastBreakdownRow({ item }) {
  const label = item.label ?? item.name ?? '—';
  const cents = item.amount_cents ?? 0;
  const isPositive = cents >= 0;

  // forecasts: champ TVA = amount_cents_vat (nomenclature backend existante)
  const vatCents = item.amount_cents_vat ?? null;
  const amountDisplay = formatHtTtc(cents, vatCents);

  return (
    <li className="flex items-center gap-2 px-4 py-2.5 text-sm border-b border-slate-100 last:border-b-0">
      {/* Badge mode */}
      <ForecastModeBadge mode={item.mode} />

      {/* Libellé + date */}
      <div className="flex-1 min-w-0">
        <span className="font-medium text-slate-800 truncate block">{label}</span>
        {item.date && (
          <span className="text-xs text-slate-400">{formatDate(item.date)}</span>
        )}
      </div>

      {/* Montant signé — HT (TTC) si TVA connue, sinon TTC seul */}
      <span
        className={`shrink-0 tabular-nums font-semibold text-sm text-right ${
          isPositive ? 'text-green-600' : 'text-red-600'
        }`}
      >
        {isPositive ? '+' : ''}{amountDisplay}
      </span>
    </li>
  );
}
